import { updateNotification } from '../../graphql/mutations';
import isInGroup from '../../services/util/isInGroup';
import {
  READ_NOTIFICATIONS_REQUESTED,
  READ_NOTIFICATIONS_COMPLETED,
  READ_NOTIFICATIONS_FAILED,
  READ_NOTIFCATIONS_ABORTED,
} from './types';
import api from '../../services/api';
import debug from '../../services/debug';

// https://docs.amplify.aws/lib/graphqlapi/getting-started/q/platform/js#enable-queries-mutations-and-subscriptions
// https://docs.amplify.aws/cli/graphql-transformer/dataaccess
const markAsReadAction = () => async (dispatch, getState) => {
  dispatch({
    type: READ_NOTIFICATIONS_REQUESTED,
  });

  try {
    const { notifications, session } = getState();
    const sessionData = session.get('data');

    if (!isInGroup(sessionData, 'Client')) {
      dispatch({
        type: READ_NOTIFCATIONS_ABORTED,
      });

      return;
    }
    const notificationsData = notifications.get('data');
    const { items } = notificationsData;
    const unreadNotifications = items.filter((item) => !item.IsRead);

    const updatedUnReadNotifications = await Promise.all(
      unreadNotifications.map(async (item) => {
        const { data } = await api.graphql({
          query: updateNotification,
          variables: {
            input: {
              id: item.id,
              IsRead: true,
            },
          },
        });
        const updatedItem = data.updateNotification;
        return updatedItem;
      }),
    );
    updatedUnReadNotifications.map((item) => {
      const foundIndex = items.findIndex((element) => element.id === item.id);
      items[foundIndex] = item;
      return item;
    });

    dispatch({
      type: READ_NOTIFICATIONS_COMPLETED,
      payload: items,
    });
  } catch (err) {
    debug(READ_NOTIFICATIONS_FAILED, err);

    dispatch({
      type: READ_NOTIFICATIONS_FAILED,
      payload: err,
    });
  }
};

export default markAsReadAction;
